module.exports = __webpack_public_path__ + "img/cover-moby-instant.34ef8520.jpg";